export const workPermit = [
    { id: -1, name: 'Select Work Permit for USA' },
    { id: 1, name: 'No' },
    { id: 2, name: 'Have H1 Visa' },
    { id: 3, name: 'TN Permit Holder' },
    { id: 4, name: 'Green Card Holder' },
    { id: 5, name: 'US Citizen' },
    { id: 6, name: 'Authorized to work in US' },
];